var _circle, _g, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMixed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 25,
    viewBox: "0 0 82 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_885",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5409,
    cy: 12.4434,
    r: 10,
    fill: "#ffffff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_885)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.5409,
    y: -0.223145,
    width: 1,
    height: 12.6665,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.54089,
    y: -0.223145,
    width: 1,
    height: 7,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5409,
    y: -0.223145,
    width: 1,
    height: 8.6665,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.54089,
    y: -0.223145,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5409,
    y: -0.223145,
    width: 1,
    height: 11,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5409,
    y: -0.223145,
    width: 1,
    height: 6,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5409,
    y: -0.223145,
    width: 1,
    height: 10,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5409,
    y: -0.223145,
    width: 1,
    height: 12,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0305 11.9452C25.3221 11.8801 25.5893 12.1472 25.5241 12.4388C24.9608 14.961 24.648 18.4783 22.8546 20.2718C21.0611 22.0653 17.5439 22.3781 15.0217 22.9415C14.7301 23.0066 14.463 22.7395 14.5281 22.4479C15.0914 19.9257 15.4042 16.4084 17.1977 14.6149C18.9912 12.8214 22.5084 12.5086 25.0305 11.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46983 5.37225C3.59446 7.24761 2.54089 9.79115 2.54089 12.4433C2.54089 15.0955 3.59446 17.639 5.46983 19.5144C7.34519 21.3897 9.88873 22.4433 12.5409 22.4433C15.1931 22.4433 17.7366 21.3897 19.612 19.5144L12.5409 12.4433L5.46983 5.37225Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3809 5.19336L36.5809 18.3934H33.3609L28.5409 5.19336H31.4609L34.2409 13.5934L35.0009 16.1934L35.7409 13.6134L38.5409 5.19336H41.3809Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0651 18.5934C45.0118 18.5934 44.0918 18.3867 43.3051 17.9734C42.5318 17.56 41.9318 16.9667 41.5051 16.1934C41.0784 15.42 40.8651 14.4867 40.8651 13.3934C40.8651 12.3 41.0784 11.3667 41.5051 10.5934C41.9318 9.82003 42.5251 9.22669 43.2851 8.81336C44.0584 8.40003 44.9384 8.19336 45.9251 8.19336C46.9384 8.19336 47.7984 8.40003 48.5051 8.81336C49.2118 9.21336 49.7518 9.76669 50.1251 10.4734C50.4984 11.1667 50.6851 11.96 50.6851 12.8534C50.6851 13.12 50.6784 13.3734 50.6651 13.6134C50.6518 13.8534 50.6318 14.0667 50.6051 14.2534H42.6251V12.3534H49.4051L48.0851 12.8334C48.0851 11.9934 47.8918 11.3467 47.5051 10.8934C47.1318 10.44 46.5984 10.2134 45.9051 10.2134C45.3984 10.2134 44.9584 10.3334 44.5851 10.5734C44.2251 10.8134 43.9518 11.1734 43.7651 11.6534C43.5784 12.12 43.4851 12.7134 43.4851 13.4334C43.4851 14.14 43.5851 14.7267 43.7851 15.1934C43.9984 15.6467 44.2918 15.9867 44.6651 16.2134C45.0518 16.44 45.5118 16.5534 46.0451 16.5534C46.6318 16.5534 47.1051 16.44 47.4651 16.2134C47.8251 15.9867 48.1051 15.6734 48.3051 15.2734L50.4851 16.1134C50.2718 16.6334 49.9451 17.08 49.5051 17.4534C49.0784 17.8267 48.5651 18.1134 47.9651 18.3134C47.3784 18.5 46.7451 18.5934 46.0651 18.5934Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4071 18.3934V8.39336H54.7871L54.9671 10.3534C55.2338 9.66003 55.6205 9.12669 56.1271 8.75336C56.6471 8.38003 57.2938 8.19336 58.0671 8.19336C58.2938 8.19336 58.5005 8.21336 58.6871 8.25336C58.8738 8.29336 59.0271 8.34669 59.1471 8.41336L58.8271 10.7134C58.6938 10.66 58.5271 10.62 58.3271 10.5934C58.1405 10.5667 57.8938 10.5534 57.5871 10.5534C57.1871 10.5534 56.8005 10.6534 56.4271 10.8534C56.0538 11.04 55.7471 11.3334 55.5071 11.7334C55.2671 12.12 55.1471 12.6134 55.1471 13.2134V18.3934H52.4071Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2446 18.3934V8.39336H62.7046L62.8646 11.3934L62.5246 11.0734C62.6846 10.42 62.938 9.88003 63.2846 9.45336C63.6313 9.02669 64.0513 8.71336 64.5446 8.51336C65.0513 8.30003 65.6046 8.19336 66.2046 8.19336C66.898 8.19336 67.5113 8.32669 68.0446 8.59336C68.5913 8.86003 69.018 9.26669 69.3246 9.81336C69.6446 10.3467 69.8046 11.02 69.8046 11.8334V18.3934H67.0646V12.6134C67.0646 11.76 66.898 11.1734 66.5646 10.8534C66.2313 10.52 65.798 10.3534 65.2646 10.3534C64.8913 10.3534 64.5246 10.4467 64.1646 10.6334C63.818 10.8067 63.5313 11.0934 63.3046 11.4934C63.0913 11.8934 62.9846 12.4267 62.9846 13.0934V18.3934H60.2446Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0564 8.39336L77.0164 19.0134C76.6964 19.92 76.3364 20.64 75.9364 21.1734C75.5497 21.7067 75.0964 22.0934 74.5764 22.3334C74.0697 22.5734 73.463 22.6934 72.7564 22.6934C72.2364 22.6934 71.7564 22.6267 71.3164 22.4934C70.8897 22.3734 70.5164 22.2134 70.1964 22.0134L70.7764 20.0334C71.0297 20.2334 71.2964 20.3734 71.5764 20.4534C71.8564 20.5467 72.1764 20.5934 72.5364 20.5934C72.9097 20.5934 73.2297 20.5134 73.4964 20.3534C73.7764 20.1934 74.0097 19.8734 74.1964 19.3934L74.5364 18.5334L73.4364 15.9334L70.3764 8.39336H73.4164L75.3164 14.3934L75.8364 16.3934L76.4564 14.2734L78.2764 8.39336H81.0564Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMixed);
export default __webpack_public_path__ + "static/media/logoMixed.5ae9349cfd0a4b76ca522a89a52ca33e.svg";
export { ForwardRef as ReactComponent };